import Vue from 'vue';
import clamp from '../util/clamp.js';

const conditionalForm = () => {
	const el = document.getElementById('form-container');
	const form = document.getElementById('form');

	if (form && !el) {
		console.error('Couldn\'t locate form container. Have you made sure to choose the Form Page template for this page?');
		form.style.display = 'none';
	}

	if (!el || !form) {
		return;
	}

	// Fetch information about the existing fields from the form element.
	const formFields = JSON.parse(form.dataset.fields);

	// Don't leave extra data floating around in the DOM.
	delete form.dataset.fields;

	const pages = form.querySelectorAll('.activity-form__page');
	const pageCount = pages ? pages.length : 1;

	new Vue({
		el,

		data: {
			submitted: false,
			formType: 'hotel',
			formFields,
			page: 0,
			error: false,
		},

		methods: {
			getFieldIsShown(type) {
				return this.formType === type || type === 'both';
			},

			getFormStepClass(step) {
				return step - 1 > this.page ? 'activity-form__step' : 'activity-form__step--active';
			},

			toggleFormType(e) {
				this.type = e.currentTarget.value;
			},

			validatePage() {
				const el = this.$el;

				let allValid = true;

				const fields = el.querySelectorAll('input, select, textarea');

				fields.forEach(field => {
					const fieldContainer = field.closest('[class*=activity-form__field]');
					const message = field.validationMessage;

					const messageContainer = fieldContainer.querySelector('.activity-form__validation-message');
					if (messageContainer) {
						messageContainer.textContent = message;
					}

					if (field.matches(':invalid')) {

						fieldContainer.classList.remove('activity-form__field--valid');
						fieldContainer.classList.add('activity-form__field--invalid');

						allValid = false;

					} else {
						fieldContainer.classList.remove('activity-form__field--invalid');
						fieldContainer.classList.add('activity-form__field--valid');
					}
				});

				return allValid;
			},

			handleNext(e) {
				// Prevent default here because on the second to last
				// page the next button was causing form submission
				// for some reason. Preventing default stops the form
				// submission event.
				e.preventDefault();

				if (this.validatePage()) {
					this.page = clamp(0, pageCount, this.page + 1);
				}
			},

			handlePrevious() {
				this.page = clamp(0, pageCount, this.page - 1);
			},

			handleSubmit(e) {
				e.preventDefault();

				if (!this.validatePage()) {
					return;
				}

				const body = JSON.stringify(Object.fromEntries(Object.entries(this.formFields)));

				const request = fetch('/wp-json/ihg/v1/submit-activity', {
					method: 'POST',
					body,
				});

				request.then(response => {
					if (response.status < 300) {
						this.submitted = true;
					} else {
						this.error = true;
					}
				});
			},
		},

	});
};

export default conditionalForm;


// WEBPACK FOOTER //
// ./scripts/modules/conditionalForm.js